import React from 'react'
import { Url } from '../../UrlServer'
import { formatUSD } from '../../../utils/formatter'
import { RootState, useAppSelector } from '../../../store'
interface CheckoutCartProps {
  total: number
}
const CheckoutCart: React.FC<CheckoutCartProps> = ({ total }) => {
  const { cart } = useAppSelector((state: RootState) => state.carts)
  return (
    <div className="ck__right">
      <h1>Shopping cart</h1>
      <span>check again and make sure about product in your purchase!</span>
      <div className="cart">
        {cart.map(item => {
          return (
            <div
              className="cart-single"
              key={item?.product._id + '' + Math.random()}
            >
              <div className="cart--infor-left">
                <div className="img--cart">
                  <img
                    src={`${Url}/${item?.product?.image}`}
                    alt={item?.product?.image}
                  />
                </div>
                <div className="infor--cart">
                  <div className="name-pr">{item?.product?.name}</div>
                  <div className="qty-pr">
                    x{item?.quantity} * {formatUSD(item?.product?.price)}
                  </div>
                  <div className="sub-pr-show-mobile">
                    {formatUSD(
                      (item?.product?.price || 0) * (item?.quantity || 1)
                    )}
                  </div>
                </div>
              </div>
              <div className="cart-price">
                <span className="line-thr">Total:</span>
                <span className="line-hidden">
                  {formatUSD(
                    (item?.product?.price || 0) * (item?.quantity || 1)
                  )}
                </span>
              </div>
            </div>
          )
        })}
      </div>
      <div className="order-step">
        <div className="total">
          Total Cart:<span>{formatUSD(total - 12.99)}</span>
        </div>
        <div className="total show-ship">
          Shipping: <span>$12.99</span>
        </div>
        <div className="total show-total">
          Total: <span>{formatUSD(total)}</span>
        </div>
      </div>
    </div>
  )
}

export default CheckoutCart
